import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchSalesChannels, clearSalesChannelsErrors } from '../../actions';
import ActionButtons from '../home/ActionButtons';
import Alert from '../home/Alert';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
const _ = require('lodash');

const propTypes = {
  dispatch: PropTypes.func,
  salesChannels: PropTypes.object,
  salesChannelsList: PropTypes.object,
  salesChannelDisabled: PropTypes.bool,
  onSalesChannelDisable: PropTypes.func,
};

class ShowSalesChannels extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      alertOpen: false,
      alertMessage: '',
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.salesChannelDelete && (this.state.delete || nextProps.salesChannels.delete)) {
      const salesChannels = nextProps.salesChannels;
      salesChannels.delete = false;
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: 'Sales Channel deleted!',
        salesChannels,
      });
      this.handleClose();
    }
    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleDisable(sc) {
    const salesChannel = _.pick(sc, ['id', 'name', 'displayName', 'subdomain', 'fulfillmentLocationId', 'campaignId',
      'classification', 'allowPayment', 'passcodeRequired', 'store', 'storeDevice']);
    salesChannel.disabled = !sc.disabled;
    // salesChannel.priceListId = (salesChannel.priceListId === null) ? 0 : salesChannel.priceListId;
    this.props.onSalesChannelDisable(salesChannel);
  }
  handleClose() {
    this.setState({
      open: false,
      disableId: 0,
    });
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearSalesChannelsErrors());
    this.props.dispatch(fetchSalesChannels({ page: 1 }));
  }
  renderRowsTable() {
    return this.props.salesChannelsList.results.map((sc, i) =>
      <TableRow key={i}>
        <TableRowColumn colSpan="1" key={i}>{sc.name}</TableRowColumn>
        <TableRowColumn colSpan="2" key={i}>{sc.displayName}</TableRowColumn>
        <TableRowColumn key={i}>{sc.subdomain}</TableRowColumn>
        <TableRowColumn key={i} colSpan="2">
          <ActionButtons
            onEdit={`/saleschannels/${sc.id}`}
            onView={`/saleschannels/view/${sc.id}`}
            onDisable={() => this.handleDisable(sc)}
            disabled={sc.disabled}
            disableForOperators
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn colSpan="1">Name</TableHeaderColumn>
              <TableHeaderColumn colSpan="2">Display Name</TableHeaderColumn>
              <TableHeaderColumn>Subdomain</TableHeaderColumn>
              <TableHeaderColumn colSpan="2" style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowSalesChannels.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowSalesChannels.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    salesChannelDisabled: state.salesChannels.salesChannelDisabled,
    salesChannelDelete: state.salesChannels.salesChannelDelete,
    error: state.salesChannels.error,
    salesChannels: state.salesChannels,
  };
}

export default connect(mapStateToProps)(ShowSalesChannels);



// WEBPACK FOOTER //
// ./src/components/salesChannels/ShowSalesChannels.js